const sizes = {
  chalk: ['S', 'L'],
  hog: ['S', 'M', 'L'],
  sobol: ['S', 'M', 'L'],
  rag: ['S', 'L'],
};

const getNameForPreset = (preset, t) => {
  if (preset[1].isOfficially) {
    const parts = preset[0].split('-');
    const type = parts[0];
    const index = (parseInt(parts[1]) || 1) - 1;
    let formattedName;

    if (sizes[type] && sizes[type][index]) {
      const upperCaseName = `${t ? t(type) : type} ${sizes[type][index]}`.toUpperCase();

      formattedName = [upperCaseName, preset[0]];
    } else {
      formattedName = preset[0];
    }

    return formattedName;
  }

  return preset[0];
};

export default getNameForPreset;
